const EVENT_ENDPOINT = process.env.REACT_APP_EVENTS_URL;
const EVENT_SECRET = process.env.REACT_APP_EVENTS_SECRET;

export async function logEvent({
  eventType,
  leagueID = "",
  userID = "",
  userName = "",
  role = "",
  source = "",
  metadata = {},
}) {
  if (!EVENT_ENDPOINT || !EVENT_SECRET) return;

  const payload = {
    secret: EVENT_SECRET,
    eventType,
    leagueID,
    userID,
    userName,
    role,
    source,
    metadata,
    userAgent: navigator.userAgent,
    url: window.location.href,
  };

  // Never block the UX on analytics
  try {
    await fetch(EVENT_ENDPOINT, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // swallow errors
  }
}